import * as orders from 'src/js/orders.js';
import { boot } from 'quasar/wrappers';
export default boot(({ app }) =>  {
    app.config.globalProperties.$orders = {...orders}
});
